import BaseRepository from "./BaseRepository";
import ProductInventoryAPICall from "../service/ProductInventoryAPICall";
import store from "../storeWire";
import storeInUse from "src/storeWire";
import ProductInventory from "src/model/ProductInventory";
import Helper from "src/support/Helper";

class ProductInventoryRepository extends BaseRepository {
    fetchProductInventoryByProducts = async (products, force_api_call = false) => {
        let inventory = {};
        if (products !== undefined &&
            Object.entries(products).length > 0) {
            let params = [];
            let product = Helper.removeDuplicateFromObjectByItemNumber(products)
            Object.entries(product).map((v) => {
                !v[1].ERPPartNumberModified && params.push({
                    sboat: v[1].Sboat,
                    ERPManufacturerCode: v[1].ERPManufacturerCode,
                    ERPPartNumber: v[1].ERPPartNumber
                })
            });
            if (params.length) {
                inventory = await new ProductInventory().setAll(
                    await new ProductInventoryAPICall().getInventory(params, force_api_call), true
                )
            }
        }
        return inventory;
    };
    refreshAllProductInventoryRunTimeAvailable = async () => {
        let master_data = {};
        if (storeInUse !== undefined && storeInUse) {
            let storeIn = await storeInUse.getState();
            master_data = storeIn.entities.model_ProductListing.master_data_only_products_list;
        }
        let params = [];
        Object.entries(master_data).map((v) => {
            params.push({
                sboat: v[1].Sboat,
                ERPManufacturerCode: v[1].ERPManufacturerCode,
                ERPPartNumber: v[1].ERPPartNumber
            })
        });
        if (params.length > 0) {
            await new ProductInventoryAPICall().getInventory(params, true);
        }
    };
    getQuantityFromCartBeforeSendToServerByERPPartNumber = async (ItemNumber) => {
        let state = store.getState();
        if (state.entities.Cart.CART_BEFORE_TO_SEND_SERVER !== undefined &&
            state.entities.Cart.CART_BEFORE_TO_SEND_SERVER[ItemNumber] !== undefined &&
            state.entities.Cart.CART_BEFORE_TO_SEND_SERVER[ItemNumber].quantityAddToCart !== undefined
        ) {
            return state.entities.Cart.CART_BEFORE_TO_SEND_SERVER[ItemNumber].quantityAddToCart;
        }
        return false;
    };
}

export default ProductInventoryRepository;